import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, propTypes, Field } from 'redux-form';
//
import { UploadFilesField, Button, DocumentIcon } from 'components';
import { replaceWithLink } from 'utils/formatting';
import { linkLOA } from 'config/data-lists/plannedNumberOfSitesList';
import { UPLOAD_URLS } from 'config/constants';

import { validate } from './validate';

@reduxForm({
  form: 'approveApplicationForm',
  validate: validate,
})
export class ApproveApplicationForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    hideModal: PropTypes.func,
    handleSubmit: PropTypes.func,
    confirmBtnText: PropTypes.string,
  };

  render() {
    const { handleSubmit, hideModal, confirmBtnText } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className="form-tile-with-image mt-10 flex flex-column align-items-center justify-content-center"
      >
        <Field
          description={replaceWithLink`
            A Letter of Authorization (LOA) from the biopharmaceutical company that makes the investigational drug you wish to obtain, grants the right of reference to the information contained in the supplier's existing Investigational New Drug (IND) application. If a LOA is not available, submit sufficient information is submitted for FDA to assure the product’s quality. A ${linkLOA} is available from FDA.
          `}
          name="letterOfAuthorization"
          component={UploadFilesField}
          title="Letter of Authorization (optional)"
          label="Upload Letter of Authorization"
          uploadURL={UPLOAD_URLS.files}
          uploadIcon={<DocumentIcon width="18px" />}
          maxFileSize={10}
          maxFileSizeErrorMessage="File should be max 10 Mb"
          allowedExtensions={['PDF', 'JPG', 'JPEG', 'DOC', 'DOCX']}
          allowedExtensionsErrorMessage="Please, upload pdf/jpg/docx"
          maxFilesCount={10}
          accept="application/pdf,image/jpeg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.doc,.docx,"
          isBackgroundErrorDisplay
        />
        <div className="mt-10 flex justify-content-space-between align-self-flex-end">
          <Button
            testId="confirm-cancel"
            className="_simple-red"
            style={{ minWidth: '180px' }}
            onClick={hideModal}
          >
            Cancel
          </Button>
          <Button
            className="_red _right"
            style={{ minWidth: '180px' }}
            type="submit"
            dataTestId="approve-application-form"
          >
            {confirmBtnText}
          </Button>
        </div>
      </form>
    );
  }
}
